// @generated by protoc-gen-es v1.10.1
// @generated from file rbt/cloud/v1alpha1/application/application.proto (package rbt.cloud.v1alpha1.application, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { LogRecord, LogsRequest_RevisionFilter, Source } from "../logs/logs_pb.js";

/**
 * @generated from enum rbt.cloud.v1alpha1.application.Status
 */
export const Status = /*@__PURE__*/ proto3.makeEnum(
  "rbt.cloud.v1alpha1.application.Status",
  [
    {no: 0, name: "UNKNOWN"},
    {no: 1, name: "UPPING"},
    {no: 2, name: "UP"},
    {no: 3, name: "DOWNING"},
    {no: 4, name: "DOWN"},
    {no: 5, name: "FAILED"},
    {no: 6, name: "EXPUNGED"},
  ],
);

/**
 * @generated from enum rbt.cloud.v1alpha1.application.ApplicationSize
 */
export const ApplicationSize = /*@__PURE__*/ proto3.makeEnum(
  "rbt.cloud.v1alpha1.application.ApplicationSize",
  [
    {no: 0, name: "XSMALL"},
    {no: 1, name: "SMALL"},
    {no: 2, name: "MEDIUM"},
    {no: 3, name: "LARGE"},
    {no: 4, name: "XLARGE"},
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.Revision
 */
export const Revision = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.Revision",
  () => [
    { no: 1, name: "number", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "container_image_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 4, name: "failure_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "size", kind: "enum", T: proto3.getEnumType(ApplicationSize), opt: true },
    { no: 7, name: "deployed_at", kind: "message", T: Timestamp },
    { no: 8, name: "deployer_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.ApplicationMetrics
 */
export const ApplicationMetrics = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.ApplicationMetrics",
  () => [
    { no: 1, name: "requests_per_second", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "p50_latency_ms", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "p95_latency_ms", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "p99_latency_ms", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.Application
 */
export const Application = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.Application",
  () => [
    { no: 2, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "space_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "space_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "application_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "revisions", kind: "message", T: Revision, repeated: true },
    { no: 8, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 10, name: "metrics", kind: "message", T: ApplicationMetrics },
    { no: 11, name: "latest_metrics_workflow_task_uuid", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 12, name: "locked_for_workflow_task_uuid", kind: "scalar", T: 12 /* ScalarType.BYTES */, opt: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.CreateRequest
 */
export const CreateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.CreateRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.CreateResponse
 */
export const CreateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.CreateResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.PushInfoRequest
 */
export const PushInfoRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.PushInfoRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.PushInfoResponse
 */
export const PushInfoResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.PushInfoResponse",
  () => [
    { no: 1, name: "registry_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "repository", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.UpRequest
 */
export const UpRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.UpRequest",
  () => [
    { no: 2, name: "digest", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "size", kind: "enum", T: proto3.getEnumType(ApplicationSize), opt: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.UpResponse
 */
export const UpResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.UpResponse",
  () => [
    { no: 2, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "revision_number", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.UpWorkflowRequest
 */
export const UpWorkflowRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.UpWorkflowRequest",
  () => [
    { no: 1, name: "revision_number", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.UpWorkflowResponse
 */
export const UpWorkflowResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.UpWorkflowResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.DownRequest
 */
export const DownRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.DownRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.DownResponse
 */
export const DownResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.DownResponse",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.DownWorkflowRequest
 */
export const DownWorkflowRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.DownWorkflowRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.DownWorkflowResponse
 */
export const DownWorkflowResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.DownWorkflowResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.RevisionStatusRequest
 */
export const RevisionStatusRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.RevisionStatusRequest",
  () => [
    { no: 1, name: "revision_number", kind: "scalar", T: 4 /* ScalarType.UINT64 */, opt: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.RevisionStatusResponse
 */
export const RevisionStatusResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.RevisionStatusResponse",
  () => [
    { no: 1, name: "revision", kind: "message", T: Revision },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.LogsRequest
 */
export const LogsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.LogsRequest",
  () => [
    { no: 3, name: "last", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 1, name: "follow", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "revisions", kind: "message", T: LogsRequest_RevisionFilter, repeated: true },
    { no: 2, name: "revision_numbers", kind: "scalar", T: 4 /* ScalarType.UINT64 */, repeated: true },
    { no: 4, name: "sources", kind: "enum", T: proto3.getEnumType(Source), repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.LogsResponse
 */
export const LogsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.LogsResponse",
  () => [
    { no: 1, name: "records", kind: "message", T: LogRecord, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.ActiveRevisionsRequest
 */
export const ActiveRevisionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.ActiveRevisionsRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.ActiveRevisionsResponse
 */
export const ActiveRevisionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.ActiveRevisionsResponse",
  () => [
    { no: 1, name: "revisions", kind: "message", T: Revision, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.StatusRequest
 */
export const StatusRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.StatusRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.StatusResponse
 */
export const StatusResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.StatusResponse",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.GetRequest
 */
export const GetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.GetRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.GetResponse
 */
export const GetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.GetResponse",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 2, name: "revisions", kind: "message", T: Revision, repeated: true },
    { no: 3, name: "metrics", kind: "message", T: ApplicationMetrics },
    { no: 4, name: "application_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.IsAdminRequest
 */
export const IsAdminRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.IsAdminRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.IsAdminResponse
 */
export const IsAdminResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.IsAdminResponse",
  () => [
    { no: 1, name: "is_admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.SetSecretsRequest
 */
export const SetSecretsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.SetSecretsRequest",
  () => [
    { no: 1, name: "secrets", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.SetSecretsResponse
 */
export const SetSecretsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.SetSecretsResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.ListSecretsRequest
 */
export const ListSecretsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.ListSecretsRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.ListSecretsResponse
 */
export const ListSecretsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.ListSecretsResponse",
  () => [
    { no: 1, name: "names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.DeleteSecretsRequest
 */
export const DeleteSecretsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.DeleteSecretsRequest",
  () => [
    { no: 1, name: "names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.DeleteSecretsResponse
 */
export const DeleteSecretsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.DeleteSecretsResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.InvalidInputError
 */
export const InvalidInputError = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.InvalidInputError",
  () => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.ConcurrentModificationError
 */
export const ConcurrentModificationError = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.ConcurrentModificationError",
  () => [
    { no: 1, name: "details", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.PaymentMethodRequiredError
 */
export const PaymentMethodRequiredError = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.PaymentMethodRequiredError",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.BillingError
 */
export const BillingError = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.BillingError",
  () => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.MetricsWorkflowRequest
 */
export const MetricsWorkflowRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.MetricsWorkflowRequest",
  () => [
    { no: 1, name: "revision_number", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.application.MetricsWorkflowResponse
 */
export const MetricsWorkflowResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.application.MetricsWorkflowResponse",
  [],
);

